// Importing code libraries for this block
import { __ } from '@wordpress/i18n';
import { registerBlockType } from '@wordpress/blocks';
import { 
	RichText,
	MediaUpload,
	MediaUploadCheck,
    PanelColorSettings,
	 } from '@wordpress/block-editor';

import { Button,ColorPalette , Modal} from '@wordpress/components';
import { reverse,omit, omitBy, map } from 'lodash';
import { useState } from '@wordpress/element';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// global._r = reverse;

/**
 * Editor styles.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
//import './editor.scss';

/**
 * Edit function.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

export default function edit( {
	className,
	attributes,
	setAttributes
} ) {

const {
    TimeLine_heading,
    CardColor,
    CardLineColor,
	start,
	end,
	titleFirst,
    contentFirst,
    yearFirst,
    mediaURLFirst,
    mediaIDFirst,
    bgcolorFirst,
    iconFirst,
    prefixiconFirst,
	titleSec,
    bgcolorSec,
    iconSec,
    prefixiconSec,
    contentSec,
    yearSec,
    mediaURLSec,
    mediaIDSec,
    info = [],
    infoDown = [],
} = attributes;

library.add(fas,fab);

var merged_icons = Object.assign(fas, fab); 


var deficonFirst   = [],
    deficonSec      = [];

jQuery.each(merged_icons, function(index, item) {
    if (item.iconName == iconFirst) {
        deficonFirst = item;
    }

    if (item.iconName == iconSec) {
        deficonSec = item;
    }
});

 var elem_parent = null;
 const click_icon =  val  => {
    var new_icon = val.target.className;

    elem_parent.text(new_icon);
    elem_parent.focus();
 };     

 const Icon_modal = () => {
     const [ isOpen, setOpen ] = useState( false );
     const openModal = (e) => {
        setOpen( true );

        var parent = jQuery(e.target).parents('.ptl-icon-cont');
        elem_parent = parent.find('.ptl-icon-text-hidden');
     }
     const closeModal = () => setOpen( false );
  
     return (
         <>
             <Button className="icon-picker-btn" variant="secondary" onClick={ openModal }>
                 <i class="fa-solid fa-image" aria-hidden="true"></i>
             </Button>
             { isOpen && (

                    <Modal overlayClassName="ptl-modal-section" title="Choose Icon" onRequestClose={ closeModal }>
                        <IconLibrary/>
                    </Modal>

             ) }
         </>
     );
 };



 const IconLibrary = () => {
    const [ filter, setFilter ] = useState( '' );
    const filteredIcons = omitBy( merged_icons, ( _icon, name ) => {

        return name.toLocaleLowerCase().indexOf( filter.toLocaleLowerCase() ) === -1;
    } );

    var filteredIcon = new Object()

    Object.keys(filteredIcons).forEach((k, i) => {
        if (i >= 0 && i < 300) {

            filteredIcon[k] = filteredIcons[k];
        }
    });

    return (
        <div className="notification-icon-Box">
            <div className="search-box">
                <input
                    id="filter-icons"
                    type="search"
                    value={ filter }
                    placeholder="Search Icon"
                    onChange={ ( event ) => setFilter( event.target.value ) }
                />
            </div>
            <div className="notification-icon-main">
                <div className="notification-icon-list">
                    <div className="icon-list">
                    { map( filteredIcon, ( icon, name ) => {
                        var alt_name = name.slice(2),
                            icon_name  = icon.iconName+','+icon.prefix;

                            return (
                                <div
                                    key={ name }
                                    className="single-icon"
                                >
                                    <strong className={icon_name}  onClick={ click_icon } style={ { width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between'} }>{ alt_name } <FontAwesomeIcon icon={icon} /></strong>

                                    
                                </div>  
                                    
                            );
                    } ) }
                    </div>
                </div>
            </div>
        </div>
    );
 };


 const arrayReverseObj = (obj) => {
   let newArray = []

   Object.keys(obj)
     .sort()
     .reverse()
     .forEach(key => {

       newArray.push(obj[key])
     })


   return newArray  
 }

    const onChangeStart = ( val ) => {
    	// debugger;
		setAttributes( {
			start : val
		} )

    };      

    const onChangeEnd = ( val ) => {
    	// debugger;
		setAttributes( {
			end : val
		} )

    };     

    const onSelectImageFirst = ( media ) => {
    	// debugger;
		setAttributes( {
			mediaURLFirst: media.url,
			mediaIDFirst: media.id
		} )

    };        
    const onSelectImageSec = ( media ) => {
    	// debugger;
		setAttributes( {
			mediaURLSec: media.url,
			mediaIDSec: media.id
		} )

    };

    const onChangeTitleFirst = ( val ) => {
    	setAttributes( {
    		titleFirst: val,
    	} )
    };        

    const onChangeTitleSec = ( val ) => {
    	setAttributes( {
    		titleSec: val,
    	} )
    };

    const onChangeContentFirst = ( val ) => {
    	setAttributes( {
    		contentFirst: val,
    	} )
    };  

    const onChangeiconFirst =  val  => {
        var attr = val.split(",");

        setAttributes( {
            iconFirst: attr[0],
            prefixiconFirst:attr[1]
        } )
    };  

    const onChangeContentSec = ( val ) => {
    	//console.log( val );
    	setAttributes( {
    		contentSec: val,
    	} )
    };  

    const onChangeYearFirst = ( val ) => {
    	//console.log( val );
    	setAttributes( {
    		yearFirst: val,
    	} )
    };   

    const onChangeYearSec = ( val ) => {
    	//console.log( val );
    	setAttributes( {
    		yearSec: val,
    	} )
    };


    const onChangeiconSec =  val  => {
        var attr = val.split(",");

        setAttributes( {
            iconSec: attr[0],
            prefixiconSec: attr[1]
        } )
    };  

    const removeMediaFirst = () => {
        setAttributes({
            mediaIDFirst: 0,
            mediaURLFirst: ''
        });
    }
    const removeMediaSec = () => {
        setAttributes({
            mediaIDSec: 0,
            mediaURLSec: ''
        });
    }



    const infoList = (value) => {
        return(
            value.sort((a, b) => a.index - b.index).map(infoItem => {

            	var num = infoItem.index;
            	var	num_class = 'timeline-section ptl-row  even';
            	var	date_class = 'pol-md-6 pol-md-push-7';
            	if(num % 2 == 0) {
            	   num_class = 'timeline-section ptl-row  odd';
            	   date_class = 'pol-md-6 pol-md-push-7';
            	}
                return(
                    <div className={num_class}>
                        <Button
                            className="remove-item"
                            onClick={ () => {
                                const newInfo = info.filter(item => item.index != infoItem.index).map(i => {
                                    if(i.index > infoItem.index){
                                        i.index -= 1;
                                    }
                                    return i;
                                } );
                                setAttributes({ info: newInfo });
                            } }
                        >&times;</Button>
                        <div className="cir-sec zoomIn" style={{ backgroundColor:'#fff' ,  borderColor:infoItem.bgcolor }}></div>
                        <div className={date_class} >
                        	<div className="ptl-date-section">
                            <h3 className="date fadeIn" style={{ color:infoItem.bgcolor}}>
                            <RichText
                                 tagName="strong"
                                 value={infoItem.year}
                                 placeholder="Enter Date"
                                 onChange={ year => {
                                     const newObject = Object.assign({}, infoItem, {
                                         year: year
                                     });
                                     setAttributes({
                                         info: [...info.filter(
                                             item => item.index != infoItem.index
                                         ), newObject]
                                     });
                                 } }
                             />
                            </h3>
                              <ColorPalette
                                className="ptl-clr-palette" 
                                color={ infoItem.bgcolor }
                                value={ '#'+infoItem.bgcolor }
                                onChange={ value => {
                                    const newObject = Object.assign({}, infoItem, {
                                        bgcolor: value
                                    });
                                    setAttributes({
                                        info: [...info.filter(
                                            item => item.index != infoItem.index
                                        ), newObject]
                                    });
                                } }
                              />
                          </div>
                        </div>
                        <div className="pol-md-6 pol-md-offset-2 data-box fadeIn panim">
                            <div className="ti-box">
                                <div className="tag-span">
                                    <RichText
                                        tagName="h2"
                                        className="ptl-p-title"
                                        placeholder="Enter the title here"
                                        value={infoItem.title}
                                        style={{ backgroundColor: infoItem.bgcolor}}
                                        onChange={ title => {
                                            const newObject = Object.assign({}, infoItem, {
                                                title: title
                                            });
                                            setAttributes({
                                                info: [...info.filter(
                                                    item => item.index != infoItem.index
                                                ), newObject]
                                            });
                                        } }
                                    />
                                    <span className="ptl-h2-span" style={{ backgroundColor:infoItem.bgcolor}}></span>
                                </div>
	                            <div className="p-collapse in">
		                            <div className="ptl-cont-box">
			                			 <div className="ptl-img-cont">
			                                <MediaUpload
			                                	className="ptl-p-img"
			    	                             onSelect={ ( media ) => {
			    	                             	const newObject = Object.assign({}, infoItem, {
			    	                             	    mediaURL: media.url,
			    	                             	    mediaID: media.id,

			    	                             	});
			    	                             	setAttributes({
			    	                             	    info: [...info.filter(
			    	                             	        item => item.index != infoItem.index
			    	                             	    ), newObject]
			    	                             	});
			    									}
			    								}
			    	                             allowedTypes = 'image'
			    	                             value={ infoItem.mediaID }
			    	                             render={ ( { open } ) => (
			    	                                 <Button className={ infoItem.mediaID ? 'image-button' : 'button button-large' } onClick={ open }>
			    	                                     { ! infoItem.mediaID ? __( 'Upload Image', 'post-timeline' ) : <img src={ infoItem.mediaURL } alt={ __( 'Upload Image', 'post-timeline' ) } />  }
			    	                                 </Button>
			    	                             ) }
			    	                         />
			                             </div>
			                             <div className="ptl-desc">
				                            <RichText
				                                tagName="div"
				                                className="ptl-content"
				                                placeholder="Enter description"
				                                value={infoItem.description}
				                                onChange={ description => {
				                                    const newObject = Object.assign({}, infoItem, {
				                                        description: description
				                                    });
				                                    setAttributes({
				                                        info: [...info.filter(
				                                            item => item.index != infoItem.index
				                                        ), newObject]
				                                    });
				                                } }
				                            />
				                        </div>
		                         	</div>
		                         </div>
	                         </div>
                         </div>
                    </div>
                )
            })
        )
    }


        const infoListDown = (value) => {
            return(
                value.sort((a, b) => a.index - b.index).map(infoItem => {

                	var num = infoItem.index;
                	var	num_class = 'timeline-section ptl-row  even';
                	var	date_class = 'pol-md-6 pol-md-push-7';
                    var deficon = [];
                    var deficonprefix = [];
                	if(num % 2 == 0) {
                	   num_class = 'timeline-section ptl-row  odd';
                	   date_class = 'pol-md-6 pol-md-push-7';
                	}
                    jQuery.each(merged_icons, function(index, item) {

                        if (item.iconName == infoItem.icon) {
                            deficon = item.iconName;
                            deficonprefix = item.prefix;
                        }
                    });

                    var fdeficon = {'prefix':deficonprefix,'iconName': deficon};

                    return(
                        <div className={num_class}>
                            <Button
                                className="remove-item"
                                onClick={ () => {
                                    const newInfoDown = infoDown.filter(item => item.index != infoItem.index).map(i => {
                                        if(i.index > infoItem.index){
                                            i.index -= 1;
                                        }
                                        return i;
                                    } );
                                    setAttributes({ infoDown: newInfoDown });
                                } }
                            >&times;</Button>
                            <div className="cir-sec zoomIn" style={{ backgroundColor:'#fff' ,  borderColor:infoItem.bgcolor }}>
                                <div className="ptl-icon-cont">
                                    <div className="ptl-small-icons">
                                        <Icon_modal/>
                                    </div>
                                    <div className="ptl-icon">
                                        <FontAwesomeIcon 
                                        icon= {fdeficon}
                                        style={{color:infoItem.bgcolor}}
                                        />
                                        <RichText
                                            value={ infoItem.icon }
                                            onChange={ icon => {
                                                var attr = icon.split(",");
                                                const newObjectDown = Object.assign({}, infoItem, {
                                                    icon: attr[0],
                                                    iconprefix: attr[1],
                                                });
                                                setAttributes({
                                                    infoDown: [...infoDown.filter(
                                                        item => item.index != infoItem.index
                                                    ), newObjectDown]
                                                });
                                            } }
                                            className="ptl-icon-text-hidden"
                                        />
                                        
                                    </div>
                                </div>
                            </div>
                            <div className={date_class} >
                            	<div className="ptl-date-section">
                                <h3 className="date fadeIn" style={{ color:infoItem.bgcolor}}>
                                <RichText
                                     tagName="strong"
                                     value={infoItem.year}
                                     placeholder="Enter Date"
                                     onChange={ year => {
                                         const newObjectDown = Object.assign({}, infoItem, {
                                             year: year
                                         });
                                         setAttributes({
                                             infoDown: [...infoDown.filter(
                                                 item => item.index != infoItem.index
                                             ), newObjectDown]
                                         });
                                     } }
                                 />
                                </h3>
                                  <ColorPalette
                                    className="ptl-clr-palette" 
                                    color={ infoItem.bgcolor }
                                    value={ '#'+infoItem.bgcolor }
                                    onChange={ value => {
                                        const newObjectDown = Object.assign({}, infoItem, {
                                            bgcolor: value
                                        });
                                        setAttributes({
                                            infoDown: [...infoDown.filter(
                                                item => item.index != infoItem.index
                                            ), newObjectDown]
                                        });
                                    } }
                                  />
                              </div>
                            </div>
                            <div className="pol-md-6 pol-md-offset-2 data-box fadeIn panim">
                                <div className="ti-box">
                                    <div className="tag-span">
                                        <RichText
                                            tagName="h2"
                                            className="ptl-p-title"
                                            placeholder="Enter the title here"
                                            value={infoItem.title}
                                            style={{ backgroundColor: infoItem.bgcolor}}
                                            onChange={ title => {
                                                const newObjectDown = Object.assign({}, infoItem, {
                                                    title: title
                                                });
                                                setAttributes({
                                                    infoDown: [...infoDown.filter(
                                                        item => item.index != infoItem.index
                                                    ), newObjectDown]
                                                });
                                            } }
                                        />

                                        <span className="ptl-h2-span" style={{ backgroundColor:infoItem.bgcolor}}></span>
                                    </div>
    	                            <div className="p-collapse in">
    		                            <div className="ptl-cont-box">
    			                			 <div className="ptl-img-cont">
                                                 <Button 
                                                     onClick={ ( media ) => {
                                                        const newObjectDown = Object.assign({}, infoItem, {
                                                            mediaURL: '',
                                                            mediaID: 0,

                                                        });
                                                        setAttributes({
                                                            infoDown: [...infoDown.filter(
                                                                item => item.index != infoItem.index
                                                            ), newObjectDown]
                                                        });
                                                        }
                                                    }
                                                    isLink isDestructive>{__('Remove image', 'p_timeline')}</Button>
    			                                <MediaUpload
    			                                	className="ptl-p-img"
    			    	                             onSelect={ ( media ) => {
    			    	                             	const newObjectDown = Object.assign({}, infoItem, {
    			    	                             	    mediaURL: media.url,
    			    	                             	    mediaID: media.id,

    			    	                             	});
    			    	                             	setAttributes({
    			    	                             	    infoDown: [...infoDown.filter(
    			    	                             	        item => item.index != infoItem.index
    			    	                             	    ), newObjectDown]
    			    	                             	});
    			    									}
    			    								}
    			    	                             allowedTypes = 'image'
    			    	                             value={ infoItem.mediaID }
    			    	                             render={ ( { open } ) => (
    			    	                                 <Button className={ infoItem.mediaID ? 'image-button' : 'button button-large' } onClick={ open }>
    			    	                                     { ! infoItem.mediaID ? __( 'Upload Image', 'post-timeline' ) : <img src={ infoItem.mediaURL } alt={ __( 'Upload Image', 'post-timeline' ) } />  }
    			    	                                 </Button>
    			    	                             ) }
    			    	                         />
    			                             </div>
    			                             <div className="ptl-desc">
    				                            <RichText
    				                                tagName="div"
    				                                className="ptl-content"
    				                                placeholder="Enter description"
    				                                value={infoItem.description}
    				                                onChange={ description => {
    				                                    const newObjectDown = Object.assign({}, infoItem, {
    				                                        description: description
    				                                    });
    				                                    setAttributes({
    				                                        infoDown: [...infoDown.filter(
    				                                            item => item.index != infoItem.index
    				                                        ), newObjectDown]
    				                                    });
    				                                } }
    				                            />
    				                        </div>
    		                         	</div>
    		                         </div>
    	                         </div>
                             </div>
                        </div>
                    )
                })
            )
        }

        var ficonFirst  = {'prefix':prefixiconFirst,'iconName': iconFirst};
        var ficonSec    = {'prefix':prefixiconSec,'iconName': iconSec};
    return(

		<div className="ptl-posts-cont p-tl-cont ptl-edit-cont ptl-cont" style={{background:CardColor}}>
            <div className="ptl-post-block-head">
                <div className="ptl-card-colors">
                    <div className="ptl-row align-items-center">
                        <div className="pol-md-3 pol-sm-4 offset-md-6 offset-sm-4 pol-6">
                            <div className="clr-piker-box d-flex align-items-center">
                                <ColorPalette
                                  className="ptl-clr-palette" 
                                  color={ CardColor }
                                  value={ '#'+CardColor }
                                  onChange={ (value) => setAttributes({ CardColor:value }) }
                                />
                                <h4>Background Color</h4>
                            </div>
                        </div>
                        <div className="pol-md-3 pol-sm-4 pol-6">
                            <div className="clr-piker-box d-flex align-items-center">
                                <ColorPalette
                                  className="ptl-clr-palette" 
                                  color={ CardLineColor }
                                  value={ '#'+CardLineColor }
                                  onChange={ (value) => setAttributes({ CardLineColor:value }) }
                                />
                                <h4>Timeline Color</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <RichText
                    tagName="h2"
                    className="ptl-post-heading"
                    value={TimeLine_heading}
                    onChange={ (value) => setAttributes({TimeLine_heading:value }) }
                    style={{color:CardLineColor}}
                />
            </div>

            <div className="ptl-content-sec">
                <span className="ptl-center-line" style={{background:CardLineColor}}></span>
    			<RichText
    			tagName="div"
    			className="ptl-sec-yr"
    			style={{background:CardLineColor}}
    			value= {start}
    			onChange={ onChangeStart }
    			/>


    			<div className="timeline-section ptl-row odd">

    				<div className="cir-sec zoomIn" style={{ backgroundColor:'#fff' , borderColor:bgcolorFirst }}>
                        <div className="ptl-icon-cont">
                            <div className="ptl-small-icons">
                                <Icon_modal/>
                            </div>
                            <div className="ptl-icon">
                                <FontAwesomeIcon 
                                icon= {ficonFirst}
                                style={{color:attributes.bgcolorFirst}}
                                />
                                <RichText
                                    value={ iconFirst }
                                    onChange={ onChangeiconFirst }
                                    className="ptl-icon-text-hidden"
                                />
                            </div>
                        </div>
                    </div>

    				<div className="pol-md-6 pol-md-push-7">
                      <div className="ptl-date-section">
                        <h3 className="date fadeIn" style={{ color : bgcolorFirst }}>
                          <RichText
                            tagName="strong"
                            value={yearFirst}
                            placeholder="Enter Date"
                            value={ yearFirst }
                            onChange={ onChangeYearFirst }
                          />
                        </h3>
                        <ColorPalette
                          className="ptl-clr-palette" 
                          color={ bgcolorFirst }
                          value={ '#'+bgcolorFirst }
                          onChange={ (value) => setAttributes({bgcolorFirst:value }) }
                        />
                      </div>
    				</div>
    				<div className="pol-md-6 pol-md-offset-2 data-box fadeIn panim">
    					<div className="ti-box">
                            <div className="tag-span">
        						<RichText
        							tagName="h2"
        							value={titleFirst}
        							placeholder="Enter the Title here"
        							className="ptl-p-title"
        							style={{ backgroundColor:bgcolorFirst}}
        							onChange={ onChangeTitleFirst }
        						/>
                                <span className="ptl-h2-span" style={{ backgroundColor:bgcolorFirst}}></span>
                            </div>
    						<div className="p-collapse in">
    							<div className="ptl-cont-box">
    								<div className="ptl-img-cont">
                                    <Button onClick={removeMediaFirst} isLink isDestructive>{__('Remove image', 'p_timeline')}</Button>
    									<MediaUpload
    										onSelect={onSelectImageFirst }
    										allowedTypes = 'image'
    										value={ mediaIDFirst }
    										render={ ( { open } ) => (
    											<Button className={ mediaIDFirst ? 'image-button' : 'button button-large' } onClick={ open }>
    												{ ! mediaIDFirst ? __( 'Upload Image', 'p_timeline' ) : <img src={ mediaURLFirst } alt={ __( 'Upload Image', 'p_timeline' ) } />  
    												}
    											</Button>
    										) }
    									/>
    								</div> 
    								<div className="ptl-desc">
    									<RichText
    										tagName="div"
    										className="ptl-content"
    										placeholder="Enter description"
    										value={contentFirst}
    										onChange={ onChangeContentFirst }
    									/>
    								</div>
    							</div>
    						</div>
    					</div>
    				</div>

    			</div>


    			<div className="timeline-section ptl-row even">

    				<div className="cir-sec zoomIn"  style={{ backgroundColor:'#fff' , borderColor:bgcolorSec }}>
                        <div className="ptl-icon-cont">
                            <div className="ptl-small-icons">
                                <Icon_modal/>
                            </div>
                            <div className="ptl-icon">
                                <FontAwesomeIcon 
                                icon= {ficonSec}
                                style={{color:attributes.bgcolorSec}}
                                />
                                <RichText
                                    value={ iconSec }
                                    onChange={ onChangeiconSec }
                                    className="ptl-icon-text-hidden"
                                />
                            </div>
                        </div>
                    </div>
    				<div className="pol-md-6 pol-md-push-7">
    					<div className="ptl-date-section">
                            <h3 className="date fadeIn" style={{ color : bgcolorSec }}>
                              <RichText
                              tagName="strong"
                              value={yearSec}
                              placeholder="Enter Date"
                              value={ yearSec }
                              onChange={ onChangeYearSec }
                              />
                            </h3>
                            <ColorPalette
                              className="ptl-clr-palette" 
                              color={ bgcolorSec }
                              value={ '#'+bgcolorSec }
                              onChange={ (value) => setAttributes({bgcolorSec:value }) }
                            />
                          </div>
    				</div>
    				<div className="pol-md-6 pol-md-offset-2 data-box fadeIn panim">
    					<div className="ti-box">
    	                    <div className="tag-span">
                                <RichText
                                    tagName="h2"
                                    value={titleSec}
                                    placeholder="Enter the Title here"
                                    className="ptl-p-title"
                                    style={{ backgroundColor:bgcolorSec}}
                                    onChange={ onChangeTitleSec }
                                />
                                <span className="ptl-h2-span" style={{ backgroundColor:bgcolorSec}}></span>
                            </div>
    						<div className="p-collapse in">
    							<div className="ptl-cont-box">
    								<div className="ptl-img-cont">
                                        <Button onClick={removeMediaSec} isLink isDestructive>{__('Remove image', 'p_timeline')}</Button>
    									<MediaUpload
    										onSelect={onSelectImageSec }
    										allowedTypes = 'image'
    										value={ mediaIDSec }
    										render={ ( { open } ) => (
    											<Button className={ mediaIDSec ? 'image-button' : 'button button-large' } onClick={ open }>
    												{ ! mediaIDSec ? __( 'Upload Image', 'p_timeline' ) : <img src={ mediaURLSec } alt={ __( 'Upload Image', 'p_timeline' ) } />  
    												}
    											</Button>
    										) }
    									/>
    								</div> 
    								<div className="ptl-desc">
    									<RichText
    									tagName="div"
    									className="ptl-content"
    									placeholder="Enter description"
    									value={contentSec}
    									onChange={ onChangeContentSec }
    									/>
    								</div>
    							</div>
    						</div>
    					</div>
    				</div>

    			</div>


    			{infoListDown(infoDown)}


    			<RichText
    			tagName="div"
    			className="ptl-sec-yr ptl-last"
    			style={{background:CardLineColor}}
    			value= {end}
    			onChange={ onChangeEnd }
    			/>

            </div>
            <div className="timeline-add-btn">
                <Button onClick={title => {
                    setAttributes({
                        infoDown: [...infoDown, {
                            index: infoDown.length,
                            title: "Memorial Day",
                            description: "Memorial Day is an American Holiday that is observed to honor the fallen U.S. military personnel.",
                            mediaURL: PTL_BLOCK.ptl_path+'admin/blocks/assets/images/Memorial-Day.jpg',
                            mediaID: "3",
                            bgcolor: "#74b9ff",
                            icon: "flag-usa",
                            iconprefix: "fas",
                            year: "29 May",
                            }]
                        });
                    }}>Add Post
                </Button>
            </div>
		</div>


    );
}